import tokens from '@bowtie-ins/bowkit/tokens';
import MuiTypography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import mapValues from 'lodash/mapValues';
import pick from 'lodash/pick';
import * as React from 'react';
import deepmerge from '../mui-deepmerge';
import { fontWeightTheme } from './tokens';
import { jsx as _jsx } from "react/jsx-runtime";
const BOWKIT_FONT = {
  h1: {
    en: tokens.fontHeadlineMEn,
    zh: tokens.fontHeadlineMZh
  },
  h2: {
    en: tokens.fontHeadlineSEn,
    zh: tokens.fontHeadlineSZh
  },
  h3: {
    en: tokens.fontTitleLEn,
    zh: tokens.fontTitleLZh
  },
  h4: {
    en: tokens.fontTitleMEn,
    zh: tokens.fontTitleMZh
  },
  subtitle1: {
    en: tokens.fontTitleXsEn,
    zh: tokens.fontTitleXsZh
  },
  body1: {
    en: tokens.fontBodyLEn,
    zh: tokens.fontBodyLZh
  },
  body2: {
    en: tokens.fontBodyMEn,
    zh: tokens.fontBodyMZh
  },
  overline: {
    en: tokens.fontBodySEn,
    zh: tokens.fontBodySZh
  }
};
const bowkitVariants = locale => {
  const variants = mapValues(BOWKIT_FONT, font => pick(font[locale], ['fontSize', 'lineHeight', 'fontWeight', 'letterSpacing']));
  return {
    ...variants,
    overline: {
      ...variants.overline,
      textTransform: 'none'
    }
  };
};
const LEGACY_ONLY_VARIANTS = {
  subtitle2: {
    fontSize: '1rem',
    lineHeight: 24 / 16,
    fontWeight: fontWeightTheme.bold
  },
  subtitle3: {
    fontSize: '1rem',
    lineHeight: 24 / 16,
    fontWeight: fontWeightTheme.bold
  },
  body: {
    fontSize: '1rem',
    lineHeight: 24 / 16,
    fontWeight: fontWeightTheme.normal
  },
  medium: {
    fontSize: '1rem',
    lineHeight: 24 / 16,
    fontWeight: fontWeightTheme.medium
  },
  bold: {
    fontSize: '1rem',
    lineHeight: 24 / 16,
    fontWeight: fontWeightTheme.bold
  }
};
export const typographyVariant = {
  ...bowkitVariants('en'),
  ...LEGACY_ONLY_VARIANTS
};
export const cjkTypographyVariant = {
  ...bowkitVariants('zh'),
  ...LEGACY_ONLY_VARIANTS
};
const useStyles = makeStyles(theme => ({
  root: ({
    fontWeight: fontWeightProp,
    lang,
    variant
  }) => {
    var _typographyVariantMap;
    const styles = variant && variant !== 'inherit' ? lang && ((_typographyVariantMap = typographyVariantMapper[lang]) === null || _typographyVariantMap === void 0 ? void 0 : _typographyVariantMap[variant]) || theme.typography[variant] : {};
    const fontWeight = fontWeightProp && fontWeightTheme[fontWeightProp] || (styles === null || styles === void 0 ? void 0 : styles.fontWeight);
    return {
      ...styles,
      fontWeight
    };
  }
}));
const extendedVariants = ['subtitle3', 'bold', 'body', 'medium'];
const typographyVariantMapper = {
  en: typographyVariant,
  'zh-hk': cjkTypographyVariant
};
const Typography = React.forwardRef((props, ref) => {
  const {
    classes: propsClasses,
    variant,
    fontWeight,
    ...rest
  } = props;
  const variantClasses = useStyles({
    fontWeight,
    lang: props.lang,
    variant
  });
  const classes = deepmerge(variantClasses, propsClasses);
  const isExtendedVariants = variant && extendedVariants.includes(variant);
  return _jsx(MuiTypography, {
    classes: classes,
    variant: isExtendedVariants ? undefined : variant,
    variantMapping: {
      overline: 'p'
    },
    ...rest,
    ref
  });
});
export default Typography;